/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface EmailTemplateRequest {
  /**
   * Indica se o template está ativo
   */
  active: boolean;
  /**
   * Descrição do template
   */
  description?: string;
  /**
   * Subtítulo do email
   */
  subTitle?: string;
  /**
   * Assunto padrão do email
   */
  subject: string;
  /**
   * ID do template no provedor
   */
  templateId: string;
  /**
   * Nome único do template
   */
  templateName: string;
}
